// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1994":"css/app.6986","2077":"css/admin-app.6986"}[chunkId] + ".css";
};